// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"72":"70f43775","318":"b877b784","532":"2925c02f","633":"a5e0af56","714":"eddd799f","893":"63dba992","894":"7030b34d"}[chunkId] + ".css";
};